import { HttpPostRequest } from '@infrastructure/axios/http-post-request';
import { IResetPasswordUseCase, PasswordReseted, ResetPasswordPayload } from '../../interfaces';

/**
 * ### Reset Password Use Case
 *
 * Use this use case if you want to reset the password.
 *
 * **Preconditions**
 * - A `RequestResetPassword` process started and user with token.
 *
 * @see {@link @core/domain/Auth/use-cases/RequestResetPassword}
 * @author <pino0071@gmail.com> Jose Aburto
 */
export default class ResetPasswordUseCase extends HttpPostRequest<ResetPasswordPayload, PasswordReseted> implements IResetPasswordUseCase {
  public async execute(payload: ResetPasswordPayload): Promise<PasswordReseted> {
    return (await this.dispatch('/auth/reset-password', payload)).data.data;
  }
}
